import { Typography } from "@mui/material";
import { GridCellParams } from "@mui/x-data-grid";
import { ColorHelper, StatusHelper } from "helpers";
import React from "react";
import { I18nTranslator } from "utils/i18n";

const ReceivingStatus = (props: GridCellParams) => {
  return (
    <Typography
      sx={{
        backgroundColor: ColorHelper.getProgressColorByQuantity(
          props.row.quantityReceived,
          props.row.quantityPlanning
        ),
        padding: "3px 16px",
        borderRadius: "3px",
        color: "white",
        fontWeight: "bold",
      }}
    >
      {I18nTranslator(
        StatusHelper.getProgressStatusByQuantity(
          props.row.quantityReceived,
          props.row.quantityPlanning
        )
      )}
    </Typography>
  );
};

export default ReceivingStatus;
